const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/media.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { getQueryClient } from "@/lib/client";
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { offerOnlyQueryOptions } from "@/queries/offer-gql";
import i18n from "@/lib/i18n";
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
  offer: SingleOffer | null;
  locale: string | undefined;
};
export const Route = createFileRoute("/{-$locale}/offers/$id/media")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context,
    params
  }) => {
    const {
      queryClient,
      locale
    } = context;
    const {
      id
    } = params;
    await queryClient.prefetchQuery({
      queryKey: ["media", {
        id: params.id
      }],
      queryFn: () => httpClient.get<Media>(`/offers/${params.id}/media`).catch(() => null)
    });
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(id, locale));
    return {
      dehydratedState: dehydrate(queryClient),
      id,
      offer,
      locale
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, [...offerOnlyQueryOptions(params.id, ctx.loaderData?.locale).queryKey]);
    if (!offer) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    return {
      meta: generateOfferMeta(offer, "Media")
    };
  }
});